import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const MaskLines = ({ lines, className = "", lineClass = "", delay = 0, inView = false }) => {
  const parent = inView
    ? { initial: "hidden", whileInView: "show", viewport: { once: true, amount: 0.1 } }
    : { initial: "hidden", animate: "show" };
  return (
    <motion.span {...parent} className={`block ${className}`}>
      {lines.map((l, i) => (
        <span key={i} className={`block overflow-hidden pb-[0.06em] ${lineClass}`}>
          <motion.span
            className="block will-change-transform"
            variants={{ hidden: { y: "105%" }, show: { y: "0%", transition: { duration: 1.15, ease: EASE, delay: delay + i * 0.11 } } }}
          >
            {l}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
};

export const FadeUp = ({ children, delay = 0, className = "", y = 28, ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.1 }}
    transition={{ duration: 0.9, ease: EASE, delay }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ n, children }) => (
  <div className="flex items-center gap-4">
    <span className="font-mono text-[12px] tracking-[0.22em] text-brand2">{n}</span>
    <span className="h-px w-10 bg-brand2/60" />
    <span className="font-mono text-[12px] uppercase tracking-[0.22em] text-zinc-400">{children}</span>
  </div>
);
